/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{HoverGesture as e}from"../../gestures/hover.js";import{FocusGesture as r}from"../../gestures/focus.js";import{PressGesture as o}from"../../gestures/press.js";import{InViewFeature as s}from"./viewport/index.js";const t={inView:{Feature:s},tap:{Feature:o},focus:{Feature:r},hover:{Feature:e}};export{t as gestureAnimations};
//# sourceMappingURL=gestures.js.map
